import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";
// import Style from "./style.module.css";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import Tooltip from "../../../../component/ui/tooltip";
import { Loader2, Trash2 } from "lucide-react";
import Select from "react-select";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  FormLineBreak,
} from "../../../../component/form/form-layout";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const AddUpdateMerchant = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  CurrentData = {},
  Style,
}) => {
  const { state } = useContext(GlobalContext);
  const apiCall = useApiCall();

  useEffect(() => {
    console.log("Merchant CurrentData", CurrentData);

    if (CurrentData?.id) {
      formik.setFieldValue("company_name", CurrentData?.company_name);
      formik.setFieldValue("short_code", CurrentData?.short_code);
      formik.setFieldValue("phone", CurrentData?.phone);
      formik.setFieldValue("address", CurrentData?.address);
    }
  }, []);

  const validationSchema = yup.object({
    company_name: yup.string().required("This Field is Required"),
    short_code: yup.string().required("This Field is Required"),
    phone: yup.string().required("This Field is Required"),
    address: yup.string().required("This Field is Required"),
  });

  // Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      company_name: "",
      short_code: "",
      phone: "",
      address: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const data = {
        company_name: values.company_name,
        short_code: values.short_code,
        phone: values.phone,
        address: values.address,
      };

      console.log("values", values);

      try {
        const url = CurrentData?.id
          ? `merchants/update-merchant/${CurrentData?.id}`
          : `merchants/add-merchant`;
        const apiRes = await apiCall({
          method: "post",
          url,
          data,
        });
        if (onSubmit) onSubmit(apiRes?.message || "Add merchant successfully");

        formik.resetForm();
        onClose();
      } catch (error) {
        const res = error?.response?.data;

        if (res?.errors) {
          formik.setErrors(
            Object.fromEntries(
              Object.entries(res.errors).map(([key, value]) => [key, value[0]]),
            ),
          );
        }
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.responseMessage ||
            error?.response?.data?.message ||
            "Something went wrong",
        );
      }
    },
  });

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
        {/* Body */}
        <div className={Style.modal_body}>
          <FormArea>
            {/* Company Name */}

            <FeildWraper width="100%">
              <FormLabel required>Company Name</FormLabel>

              <input
                type="text"
                name="company_name"
                value={formik.values.company_name}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                placeholder="Company Name"
              />
              {formik.touched.company_name && formik.errors.company_name && (
                <FeildError>{formik.errors.company_name}</FeildError>
              )}
            </FeildWraper>

            {/* Short Code */}
            <FeildWraper width="100%">
              <FormLabel required>Short Code</FormLabel>
              <input
                type="text"
                name="short_code"
                value={formik.values.short_code}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                placeholder="Short Code"
              />
              {formik.touched.short_code && formik.errors.short_code && (
                <FeildError>{formik.errors.short_code}</FeildError>
              )}
            </FeildWraper>

            {/* Phone */}
            <FeildWraper width="100%">
              <FormLabel required>Phone</FormLabel>
              <input
                type="text"
                name="phone"
                value={formik.values.phone}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                placeholder="Phone"
              />
              {formik.touched.phone && formik.errors.phone && (
                <FeildError>{formik.errors.phone}</FeildError>
              )}
            </FeildWraper>

            {/* Address */}

            <FeildWraper width="100%">
              <FormLabel required>Address</FormLabel>
              <input
                type="text"
                name="address"
                value={formik.values.address}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                placeholder="Address"
              />
              {formik.touched.address && formik.errors.address && (
                <FeildError>{formik.errors.address}</FeildError>
              )}
            </FeildWraper>
          </FormArea>
        </div>

        {/* Footer */}
        <div className={Style.modal_foot}>
          <button
            type="button"
            className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            {CurrentData?.id ? "Update" : "Apply"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddUpdateMerchant;
